import React from 'react';
import MainPage from '../main-page/main-page';

function App() {
  return <MainPage />;
}

export default App;

